import { render, staticRenderFns } from "./FileDocumentUpload.vue?vue&type=template&id=0d869ec4"
import script from "./FileDocumentUpload.vue?vue&type=script&lang=js"
export * from "./FileDocumentUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports